import { Service } from 'typedi';
import { BaseService, IBaseService } from '../../../core/services/BaseService';
import { Appl } from '../../../core/Appl';

export interface IReleaseNoteService extends IBaseService {
}

@Service() // eslint-disable-next-line
export class ReleaseNoteService extends BaseService implements IReleaseNoteService {
    constructor() {
        super(`${Appl.Setting.Services.UtilityServiceUrl}`);
    }
}
